// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--2R8Y7","cardHeading":"Card-module--cardHeading--m4RNs","svgSizer":"Card-module--svgSizer--qOn29"};